import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "banner"]

  connect() {
    this.autoDismissTimer = null
  }

  disconnect() {
    if (this.autoDismissTimer) {
      clearTimeout(this.autoDismissTimer)
    }
  }

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  handleSubmit(event) {
    if (event.detail.success) {
      this.close()
      this.showBanner()
    }
  }

  showBanner() {
    this.bannerTarget.classList.remove("hidden")
    this.autoDismissTimer = setTimeout(() => {
      this.dismissBanner()
    }, 5000)
  }

  dismissBanner() {
    this.bannerTarget.classList.add("hidden")
    if (this.autoDismissTimer) {
      clearTimeout(this.autoDismissTimer)
      this.autoDismissTimer = null
    }
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }
}
